import React from 'react';
import { createTheme } from '@material-ui/core';

import {
  FOG_20,
  OwnUpComponentLibraryProvider,
  ownUpLightTheme
} from '@rategravity/own-up-component-library';
import { OwnUpThemeWrapper } from '@rategravity/own-up-component-library-legacy';
import tailwindPaths from './config/migrated-pathes.json';
import { breakpoints } from './src/modules/breakpoints';

export const OwnUpStyledComponentsLibraryWrapper = ({ children, pathname }) => {
  if (tailwindPaths.tailwindPaths.includes(pathname)) {
    return <>{children}</>;
  }

  const theme = createTheme({
    ...ownUpLightTheme,
    palette: {
      ...ownUpLightTheme.palette,
      background: {
        default: FOG_20
      }
    }
  });

  return (
    <OwnUpComponentLibraryProvider theme={theme}>
      <OwnUpThemeWrapper breakpoints={breakpoints} preload_advisors={false}>
        {children}
      </OwnUpThemeWrapper>
    </OwnUpComponentLibraryProvider>
  );
};
